var _style, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSi2Logo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 397.4 226.2",
    style: {
      enableBackground: "new 0 0 397.4 226.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2AB9D1;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#CECECE;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.9,77.3l-58.4,20c-1.6,0.6-1.1,3,0.6,2.8c20.4-2.8,40.9-5.5,61.3-8.3c4.7-0.6,7.8-5.1,7-9 C82.6,78.6,77.7,75.6,72.9,77.3L72.9,77.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109,62.2l12.4-60.5c0.3-1.7-2-2.5-2.7-0.9c-8,19-16,38-23.9,57c-1.9,4.4,0.4,9.3,4.2,10.6 C102.9,69.9,108,67.2,109,62.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.3,102.2l44.1,43.3c1.2,1.2,3.2-0.4,2.2-1.8c-11.6-17-23.3-34.1-34.9-51.1c-2.7-4-8-4.7-11.2-2.2 C104.1,92.9,103.7,98.7,107.3,102.2L107.3,102.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,182.7V157h13.2v2.5c0.5,3.5,2.4,6.4,5.7,8.7c3.3,2.3,7.3,3.4,11.8,3.4c4.8,0,8.6-0.8,11.4-2.5 c2.8-1.7,4.3-4,4.3-6.9c0-2.8-1.2-4.9-3.5-6.3c-2.4-1.3-7-2.6-14-3.7c-10.3-1.7-17.7-4.6-22.2-8.5c-4.4-3.9-6.6-9-6.6-15.2 c0-6.3,2.4-11.5,7.2-15.7c4.8-4.2,11.1-6.3,19-6.3c7.1,0,13.2,1.5,18.3,4.4v-3.2h13.1v24.9H51.1V128c-4-6.2-9.8-9.2-17.4-9.2 c-3.9,0-7.1,0.8-9.6,2.5c-2.5,1.7-3.8,3.9-3.8,6.7c0,2.8,1.2,4.8,3.5,5.9c2.3,1.1,7.3,2.2,14.9,3.4c7.3,1.1,12.8,2.5,16.5,4 c3.7,1.5,6.8,4.1,9.3,7.6s3.7,7.7,3.7,12.4c0,7-2.7,12.5-8,16.7c-5.4,4.1-12.3,6.2-20.8,6.2c-8,0-14.6-1.8-19.6-5.5v4.2H6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.6,169.6v-48.9H78v-13.1h26.4v62H116v13.1H78v-13.1H89.6z M87.5,82.1c0-2.4,0.8-4.4,2.5-6.2 c1.7-1.8,3.8-2.6,6.4-2.6c2.4,0,4.5,0.9,6.3,2.6c1.8,1.7,2.6,3.8,2.6,6.3c0,2.5-0.9,4.6-2.6,6.3c-1.8,1.7-3.9,2.6-6.3,2.6 c-2.5,0-4.6-0.9-6.3-2.6C88.4,86.6,87.5,84.5,87.5,82.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.3,68.5l-0.4,14.6h-26.1c0-2.8,0.5-5.5,1.5-8.1c1-2.6,2.4-4.8,4.3-6.7s4.6-4.2,8.4-7 c2.4-1.7,4-3.2,4.8-4.4s1.3-2.5,1.3-4.1c0-1.9-0.6-3.4-1.8-4.6c-1.2-1.2-2.8-1.8-4.9-1.8c-2.4,0-4.2,0.7-5.4,2.1 c-1.1,1.4-1.7,3.6-1.7,6.8c0,0.8,0,1.5,0.1,2.2h-5.4c0-0.7,0-1.3,0-1.7c0-4.4,1-7.9,3.1-10.4c2.1-2.5,5.2-3.7,9.2-3.7 c4.1,0,7.2,1.1,9.4,3.2c2.2,2.1,3.3,4.8,3.3,7.9c0,2.6-0.7,4.8-2.1,6.7c-1.4,1.8-4.2,4.2-8.2,7c-3.9,2.8-6.5,5-7.7,6.8 c-1.2,1.7-1.9,3.3-2.1,4.6h15.4l0.2-9.3H145.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189,79.4c0,2.3-1.2,3.5-3.5,3.5h-9.5c-2.3,0-3.5-1.2-3.5-3.5v-6.9h4.1v6.8h8.4v-6l-10.8-8.9 c-1-0.8-1.6-1.9-1.6-3.2v-5c0-2.3,1.2-3.5,3.5-3.5h9.3c2.3,0,3.5,1.2,3.5,3.5v6h-4v-6h-8.4v5.3l10.9,8.9c1,0.8,1.5,1.9,1.5,3.3 V79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.9,82.9h-4.1v-0.8c-1.7,0.2-3.3,0.4-4.9,0.7c-2,0.2-3.6,0.4-4.9,0.4c-2.2,0-3.4-1.1-3.4-3.4v-27h4.1v26.5 l9.2-0.2V52.7h4.1V82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.9,79.4c0,2.3-1.2,3.5-3.5,3.5h-9.5c-2.3,0-3.5-1.2-3.5-3.5v-6.9h4.1v6.8h8.4v-6L221,64.5 c-1-0.8-1.6-1.9-1.6-3.2v-5c0-2.3,1.2-3.5,3.5-3.5h9.3c2.3,0,3.5,1.2,3.5,3.5v6h-4v-6h-8.4v5.3l10.9,8.9c1,0.8,1.5,1.9,1.5,3.3 V79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.3,82.9h-5.9c-2.3,0-3.5-1.2-3.5-3.5V56.3h-3.6v-3.6h3.6v-9.4h4.1v9.4h5.3v3.6h-5.3v22.9h5.3V82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.7,82.9h-4.1v-0.8c-1.6,0.2-3.3,0.4-4.9,0.7c-2,0.2-3.7,0.4-4.9,0.4c-2.3,0-3.4-1.1-3.4-3.4v-11 c0-2.3,1.2-3.5,3.5-3.5h9.7v-9.1h-8.9v5.2h-4v-5.1c0-2.3,1.2-3.5,3.5-3.5h9.9c2.3,0,3.5,1.2,3.5,3.5V82.9z M271.7,79.2V68.5h-9.2 v10.9L271.7,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.8,46.1h-4.2v-5.2h4.2V46.1z M286.8,82.9h-4.1V52.7h4.1V82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.2,82.9H307V56.4l-9.1,0.2v26.3h-4.1V52.7h4.1v0.8c1.6-0.2,3.2-0.4,4.9-0.7c2-0.2,3.6-0.4,4.9-0.4 c2.3,0,3.4,1.1,3.4,3.4V82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.9,82.9h-4.1v-0.8c-1.6,0.2-3.3,0.4-4.9,0.7c-2,0.2-3.7,0.4-4.9,0.4c-2.3,0-3.4-1.1-3.4-3.4v-11 c0-2.3,1.2-3.5,3.5-3.5h9.7v-9.1H322v5.2h-4v-5.1c0-2.3,1.2-3.5,3.5-3.5h9.9c2.3,0,3.5,1.2,3.5,3.5V82.9z M330.9,79.2V68.5h-9.2 v10.9L330.9,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359,76.4c0,1.9-0.6,3.4-1.8,4.6s-2.8,1.8-4.6,1.8h-10.9V34.3h4.1v19.2c1.6-0.2,3.3-0.4,4.9-0.6 c2.1-0.3,3.7-0.4,4.9-0.4c2.3,0,3.4,1.1,3.4,3.4V76.4z M354.9,75.8V56.4l-9.1,0.2v22.6h5.7C353.8,79.3,354.9,78.1,354.9,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.1,82.9H366V34.3h4.1V82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394,79.4c0,2.3-1.2,3.5-3.5,3.5h-9.9c-2.3,0-3.5-1.2-3.5-3.5V56.2c0-2.3,1.2-3.5,3.5-3.5h9.9 c2.3,0,3.5,1.2,3.5,3.5v10.9l-1.4,1.5h-11.5v10.9h8.9v-5.5h4V79.4z M390,65.2v-9.1h-8.9v9.1H390z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.9,95.5h-4.2v-5.2h4.2V95.5z M176.8,132.4h-4.1v-30.2h4.1V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.2,132.4h-4.1v-26.5l-9.1,0.2v26.3h-4.1v-30.2h4.1v0.8c1.6-0.2,3.2-0.4,4.9-0.7c2-0.2,3.6-0.4,4.9-0.4 c2.3,0,3.4,1.1,3.4,3.4V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.2,132.4h-4.1v-26.5l-9.1,0.2v26.3h-4.1v-30.2h4.1v0.8c1.6-0.2,3.2-0.4,4.9-0.7c2-0.2,3.6-0.4,4.9-0.4 c2.3,0,3.4,1.1,3.4,3.4V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.3,128.9c0,2.3-1.2,3.5-3.5,3.5h-10.4c-2.3,0-3.5-1.2-3.5-3.5v-23.2c0-2.3,1.2-3.5,3.5-3.5h10.4 c2.3,0,3.5,1.2,3.5,3.5V128.9z M245.1,128.7v-22.9H236v22.9H245.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273,102.1l-7.5,30.3h-3.8l-7.5-30.3h4.3l5.2,23.8l5.2-23.8H273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.2,132.4h-4.1v-0.8c-1.6,0.2-3.3,0.4-4.9,0.7c-2,0.2-3.7,0.4-4.9,0.4c-2.3,0-3.4-1.1-3.4-3.4v-11 c0-2.3,1.2-3.5,3.5-3.5h9.7v-9.1h-8.9v5.2h-4v-5.1c0-2.3,1.2-3.5,3.5-3.5h9.9c2.3,0,3.5,1.2,3.5,3.5V132.4z M291.2,128.6v-10.7 h-9.2v10.9L291.2,128.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.8,132.4h-5.9c-2.3,0-3.5-1.2-3.5-3.5v-23.1h-3.6v-3.6h3.6v-9.4h4.1v9.4h5.3v3.6h-5.3v22.9h5.3V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322.5,95.5h-4.2v-5.2h4.2V95.5z M322.4,132.4h-4.1v-30.2h4.1V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.8,128.9c0,2.3-1.2,3.5-3.5,3.5h-10.4c-2.3,0-3.5-1.2-3.5-3.5v-23.2c0-2.3,1.2-3.5,3.5-3.5h10.4 c2.3,0,3.5,1.2,3.5,3.5V128.9z M342.6,128.7v-22.9h-9.1v22.9H342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.9,132.4h-4.1v-26.5l-9.1,0.2v26.3h-4.1v-30.2h4.1v0.8c1.6-0.2,3.2-0.4,4.9-0.7c2-0.2,3.6-0.4,4.9-0.4 c2.3,0,3.4,1.1,3.4,3.4V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M393.8,128.9c0,2.3-1.2,3.5-3.5,3.5h-9.5c-2.3,0-3.5-1.2-3.5-3.5V122h4.1v6.8h8.4v-6l-10.8-8.9 c-1-0.8-1.6-1.9-1.6-3.2v-5c0-2.3,1.2-3.5,3.5-3.5h9.3c2.3,0,3.5,1.2,3.5,3.5v6h-4v-6h-8.4v5.3l10.9,8.9c1,0.8,1.5,1.9,1.5,3.3 V128.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177,146.2h-4.2V141h4.2V146.2z M176.9,183.1h-4.1v-30.2h4.1V183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.3,183.1h-4.1v-26.5l-9.1,0.2v26.3h-4.1v-30.2h4.1v0.8c1.6-0.2,3.2-0.4,4.9-0.7c2-0.2,3.6-0.4,4.9-0.4 c2.3,0,3.4,1.1,3.4,3.4V183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.2,179.6c0,2.3-1.2,3.5-3.5,3.5h-9.5c-2.3,0-3.5-1.2-3.5-3.5v-6.9h4.1v6.8h8.4v-6l-10.8-8.9 c-1-0.8-1.6-1.9-1.6-3.2v-5c0-2.3,1.2-3.5,3.5-3.5h9.3c2.3,0,3.5,1.2,3.5,3.5v6h-4v-6h-8.4v5.3l10.9,8.9c1,0.8,1.5,1.9,1.5,3.3 V179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.7,183.1h-5.9c-2.3,0-3.5-1.2-3.5-3.5v-23.1h-3.6v-3.6h3.6v-9.4h4.1v9.4h5.3v3.6h-5.3v22.9h5.3V183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.3,146.2h-4.2V141h4.2V146.2z M251.2,183.1h-4.1v-30.2h4.1V183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.1,183.1h-5.9c-2.3,0-3.5-1.2-3.5-3.5v-23.1h-3.6v-3.6h3.6v-9.4h4.1v9.4h5.3v3.6h-5.3v22.9h5.3V183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.7,183.1h-4.1v-0.8c-1.7,0.2-3.3,0.4-4.9,0.7c-2,0.2-3.6,0.4-4.9,0.4c-2.2,0-3.4-1.1-3.4-3.4v-27h4.1v26.5 l9.2-0.2v-26.3h4.1V183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.3,183.1h-5.9c-2.3,0-3.5-1.2-3.5-3.5v-23.1h-3.6v-3.6h3.6v-9.4h4.1v9.4h5.3v3.6H304v22.9h5.3V183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.5,179.6c0,2.3-1.2,3.5-3.5,3.5h-9.9c-2.3,0-3.5-1.2-3.5-3.5v-23.2c0-2.3,1.2-3.5,3.5-3.5h9.9 c2.3,0,3.5,1.2,3.5,3.5v10.9l-1.4,1.5h-11.5v10.9h8.9v-5.5h4V179.6z M327.5,165.4v-9.1h-8.9v9.1H327.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi2Logo2);
export default __webpack_public_path__ + "static/media/si2logo2.f8104e74e06ff7d85d8f6958fb095bf9.svg";
export { ForwardRef as ReactComponent };